// extracted by css-extract-rspack-plugin
export default {"timeline":"C7YOv6","row":"sKvvD2","dot":"_3rluDU","date":"nxLnHd","header":"gT2Lhc","icon":"sIQWGK","body":"MPOMB2"};